import z from "zod";

export const CertificationSchema = z
  .object({
    id: z.number().optional(),
    // Accept only snake_case from server but allow nulls
    certificate_type: z.string().nullable().optional(),
    name: z.string().nullable().optional(),
    location: z.string().nullable().optional(),
    received_at: z.string().nullable().optional(),
    certificate: z.string().nullable().optional(),
    user_id: z.string().optional(),
  })
  .transform((c) => ({
    id: c.id,
    certificateType: c.certificate_type ?? null,
    name: c.name ?? "",
    location: c.location ?? null,
    receivedAt: c.received_at ?? null,
    certificate: c.certificate ?? null,
    user_id: c.user_id,
  }));

export type Certification = z.infer<typeof CertificationSchema>;

export const CertificationsResponseSchema = z.object({
  certifications: z.array(CertificationSchema),
  message: z.string().nullable(),
  success: z.boolean(),
});

export type CertificationsResponse = z.infer<
  typeof CertificationsResponseSchema
>;
